<template lang="pug">
    model-form(
        ref='form'
        submit-text='guardar'
        title='Crear liquidación de sueldo'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
        template( slot='footer-actions' )
            v-btn(
                block
                class='ml-3'
                color='secondary'
                @click='submitConfirm'
            ) guardar y confirmar
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import SalarySettlementModel from '@/models/HumanResource/HrSalarySettlement'
    import IndicatorModel from '@/models/HumanResource/HrIndicator'
    import SalarySettlementFields from '@/views/HumanResource/HrSalarySettlement/partials/HrSalarySettlementFields'
    //
    export default {
        name: 'salary-settlement-create',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             * 
             */
            fieldsProps() {
                return {
                    indicators: this.indicators,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    fields: SalarySettlementFields(this.fieldsProps),
                }
            }
        },
        data() {
            return {
                formData: new SalarySettlementModel({
                    advance: 0,
                    apv: 0,
                    apv_afp: 0,
                    bonuses: 0,
                    extra_hh_hours: 0,
                    extra_hh_minutes: 0,
                    discount_hh_hours: 0,
                    discount_hh_minutes: 0,
                    loan_ccaf_quote_amount: 0,
                    selected: [],
                    unique_tax_amount: 0,
                    worked_days: 30,
                }),
                indicators: [],
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * 
             */
            confirm() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toCreate)
                    .then(this.prepateConfirm)
                    .then(this.toConfirm)
                    .then(this.successConfirm)
                    .then(this.redirect)
                    .catch(this.error)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            create() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toCreate)
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
                    .then(this.$refs.form.setWait)
            },

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(SalarySettlementModel, error.response.data))
            },

            /**
             * 
             */
            prepateConfirm(res) {
                this.formData.id = res.salary_settlement_id
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'salary-settlement-list' })
            },

            /**
             * 
             */
            reset() {
                IndicatorModel
                    .limit(-1)
                    .get()
                    .then(this.setIndicators)
            },

            /**
             * Sets the indicators.
             *
             * @param      {Object}  arg1       The argument 1
             * @param      {<type>}  arg1.data  The data
             */
            setIndicators({ data }) {
                this.indicators = data
            },


            /**
             * 
             */
            submit() {
                return this.create()
            },

            /**
             * 
             */
            submitConfirm() {
                this.setWarningSnackbar({
                    title: '¿Desea confirmar la liquidación de sueldo?',
                    message: 'Una vez confirmada no se puede editar.',
                    confirm: 'confirmar',
                })
            },

            /**
             * 
             */
            success() {
                this.setSuccessSnackbar('Liquidacion de sueldo agregada exitosamente.')
            },

            /**
             * 
             */
            successConfirm() {
                this.setSuccessSnackbar('Liquidación de sueldo guardada y confirmada exitosamente.')
            },

            /**
             *
             */
            toConfirm() {
                return this.formData
                    .confirm()
                    .attach()
            },

            /**
             *
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
            },
        },
        watch: {

            /**
             * 
             */
            responseConfirm(val) {
                switch (val) {
                    case 'confirmar': return this.confirm()
                }
            }
        },
        mounted() {
            this.setTitleTopBar('Crear liquidacion de sueldo')
            this.reset()
        },
    }
</script>